import { Injectable } from '@angular/core';

import { OccCheckoutAdapter } from '@spartacus/checkout/base/occ';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DpOccCheckoutAdapter extends OccCheckoutAdapter {
  // TODO: remove disabled eslint rules
  // eslint-disable-next-line max-len
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  clearCheckoutDeliveryMode(userId: string, cartId: string): Observable<any> {
    return of(null);
  }
}
